<template>
  <div>
    <CreatePickUp />
  </div>
</template>

<script>
import CreatePickUp from './CreatePickUp'
import { mutations } from '../store'

export default {
  name: 'PickUpScreen',
  components: {
    CreatePickUp
  },
  async created() {

    const profile = this.$store.getters.getProfile

    const fullName =
      profile.nombre + ' ' + profile.apellido
    const appId = profile.aplicacion.id

    mutations.setUserProfile({ fullName, appId })
  }
}
</script>

<style lang="scss" scoped></style>
